import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch, onMounted } from "vue";

type Attachment = {
    _id: string;
    title: string;
    size: number;
    link: string;
    extension: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DropZoneDropbox',
  props: {
    apiKey: {
        type: String,
        required: true,
    },
    linkType: {
        type: String,
        default: "preview",
    },
    multiselect: {
        type: Boolean,
        default: false,
    },
    extensions: {
        type: Array,
        default: function () {
            return [];
        },
    },
    folderselect: {
        type: Boolean,
        default: false,
    },
    sizeLimit: {
        type: Number,
        default: 0,
    },
    buttonType: {
        type: String,
        default: "chooser",
    },
    uploadFiles: {
        type: Array,
        default: function () {
            return [];
        },
    },
},
  emits: ["picked", "cancel", "saved", "progress", "error"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const scriptLoaded = ref(false);
const dropboxChooserIsSupported = ref(false);
const saverRendered = ref(false);
const tempAttachments = ref<Attachment[]>([]);

const dropboxIconClicked = () => {
    debugger;
    const options = {
        success: async (files) => {
            const attachments: Array<Attachment> = [];

            for (let i = 0; i < files.length; i++) {
                const attachment = {
                    _id: files[i].id,
                    title: files[i].name,
                    size: files[i].bytes,
                    link: files[i].link,
                    extension: files[i].name.split(".")[1].toUpperCase(),
                };
                attachments.push(attachment);
            }
            tempAttachments.value = attachments;
            emits("picked", tempAttachments.value);
        },

        cancel: function () {
            emits("cancel");
        },

        extensions: undefined,
        sizeLimit: undefined,

        linkType: props.linkType,
        multiselect: props.multiselect,
        folderselect: props.folderselect,
    };

    if (props.extensions.length) {
        options.extensions = props.extensions;
    }

    if (props.sizeLimit) {
        options.sizeLimit = props.sizeLimit;
    }
    window["Dropbox"].choose(options);
};

const dropboxSaverIconClicked = () => {
    const options = {
        files: props.uploadFiles,
        success: function () {
            emits("saved");
        },
        cancel: function () {
            emits("cancel");
        },
        progress: function (progress) {
            emits("progress", { progress });
        },
        error: function (errorMessage) {
            emits("error", { errorMessage });
        },
    };

    window["Dropbox"].save(options);
};

const initButtonAction = () => {
    if (scriptLoaded.value && props.uploadFiles.length && !saverRendered.value) {
        const options = {
            files: props.uploadFiles,
            success: function () {
                emits("saved");
            },
            cancel: function () {
                emits("cancel");
            },
            progress: function (progress) {
                emits("progress", { progress: progress });
            },
            error: function (errorMessage) {
                emits("error", { errorMessage: errorMessage });
            },
        };

        const button = window["Dropbox"].createSaveButton(options);
        document.getElementById("container-db").appendChild(button);
        saverRendered.value = true;
    }
};

watch(scriptLoaded, initButtonAction, { immediate: true });
watch(props.uploadFiles, initButtonAction, { immediate: true });
watch(saverRendered, initButtonAction, { immediate: true });

onMounted(() => {
    if (window["Dropbox"]) {
        scriptLoaded.value = true;
        dropboxChooserIsSupported.value = window["Dropbox"].isBrowserSupported();

        if (!dropboxChooserIsSupported.value) {
            console.warn("Dropbox chooser is not supported in this browser");
        }
    } else {
        const dropBoxScript = document.createElement("script");
        dropBoxScript.onload = () => {
            scriptLoaded.value = true;
            dropboxChooserIsSupported.value = window["Dropbox"].isBrowserSupported();

            if (!dropboxChooserIsSupported.value) {
                console.warn("VueDropboxPicker: This browser is not supported");
            }
        };
        dropBoxScript.setAttribute("src", "https://www.dropbox.com/static/api/2/dropins.js");
        dropBoxScript.setAttribute("id", "dropboxjs");
        dropBoxScript.setAttribute("data-app-key", props.apiKey);
        document.head.appendChild(dropBoxScript);
    }
});

return (_ctx: any,_cache: any) => {
  return (scriptLoaded.value && dropboxChooserIsSupported.value && __props.buttonType === 'chooser')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: dropboxIconClicked
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _cache[0] || (_cache[0] = _createElementVNode("button", null, "Open dropbox picker", -1))
        ])
      ]))
    : (scriptLoaded.value && dropboxChooserIsSupported.value && __props.buttonType === 'saver')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: dropboxSaverIconClicked,
          id: "container-db"
        }))
      : _createCommentVNode("", true)
}
}

})